<template>
  <transition
    enter-active-class="transition duration-300 ease-out transform"
    enter-class="scale-95 opacity-0"
    enter-to-class="scale-100 opacity-100"
    leave-active-class="transition duration-150 ease-in transform"
    leave-class="scale-100 opacity-100"
    leave-to-class="scale-95 opacity-0"
  >
    <div
      v-if="openModal"
      class="flex items-center justify-center fixed left-0 bottom-0 w-full h-full z-50"
      style="background-color: #00000099"
    >
      <div class="bg-white rounded-lg w-1/4">
        <div class="flex flex-col items-start p-4">
          <div class="flex items-center w-full">
            <div class="text-gray-900 font-bold text-lg">
              {{ title }}
            </div>
            <svg
              class="ml-auto fill-current text-gray-700 w-6 h-6 cursor-pointer"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 18 18"
              @click="handlePopups"
            >
              <path
                d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
              />
            </svg>
          </div>
          <hr class="w-full my-3 " />
          <div class=" text-left">{{ message }}</div>
          <hr class="w-full my-3" />
          <div class="ml-auto">
            <button class="btn btn-primary" @click="callback">Delete</button>
            <button class="btn btn-outline ml-3" @click="handlePopups">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
// import utils from '@/services/utils';

export default {
  name: 'CourseDeleteModal',
  props: ['title', 'message', 'callback', 'openModal', 'handlePopups'],
//   methods: {
//     handleDeleteCourse() {
//       try {
//         const payload = {
//             courseId:
//         }
//       } catch (error) {
//         utils.setStatusMsg(
//           this,
//           error?.response?.data?.message || 'Something went wrong',
//         );
//       }
//     },
//   },
};
</script>

<style></style>
